import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  SapDocumentTypeCreateDto,
  SapDocumentTypeDto,
  SapDocumentTypeExcelDownloadDto,
  SapDocumentTypeService,
  SapDocumentTypeUpdateDto,
} from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { SAPDOCUMENTTYPE_CONFIG, SAPDOCUMENTTYPE_FIELDS } from './sap-document-type.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-document-type',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapDocumentTypeService, ConfirmationService],
  templateUrl: './sap-document-type.html',
  styleUrl: './sap-document-type.scss',
})
export class SapDocumentType extends BaseHierarchicalCrudComponent<
  SapDocumentTypeDto,
  SapDocumentTypeCreateDto,
  SapDocumentTypeUpdateDto,
  SapDocumentTypeExcelDownloadDto
> {
  service = inject(SapDocumentTypeService);
  config = SAPDOCUMENTTYPE_CONFIG;
  fields = SAPDOCUMENTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapDocumentTypeDto): SapDocumentTypeUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapDocumentType';
  }
}
